export const GRADE_TYPE_LABELS = {
  freeform: 'Free form',
  percentage: 'Percentages',
  rubric: 'Rubric',
  passFail: 'Pass/Fail',
};

export const STATUS_TOOLTIPS = {
  upcoming:
    'This assignment block is visible to students but they cannot access it until the open date.',
  open: 'The assignment is open for submissions.',
  nearDueDate: 'The assignment is open for submissions.',
  pastDueDate:
    'The due date is past but the assignment is still open for submissions.',
  closed:
    'The assignment is closed and does not accept submissions at this point.',
  submitted: 'Submitted',
  submittedLate: 'Submitted Late',
  notSubmitted: 'Not Submitted',
  manualAssignment: 'This is a manually graded assignment.',
};

export const EXISTING_SUBMISSION_CONFLICT_MESSAGES = {
  title: 'Existing submissions found',
  currentExtension:
    'The operation couldn’t be completed because the following students still have a submission in the extension. Please delete their submission before removing them from this extension.',
  default:
    'The operation couldn’t be completed because the following students have submissions. Please delete one of their submissions and try again.',
  turnitin:
    'The operation couldn’t be completed because the following students have submissions. Please open this assignment in Turnitin and delete one of their submissions before trying again.',
  close: 'Close',
};

export const NO_STUDENT_EXTENSION = {
  TITLE: 'No students are assigned to this extension',
  MESSAGE:
    'To assign students, hover over this extension in the extension list and click on the 3 dots to edit the extension.',
};

export const NO_STUDENT_MAIN_COHORT = {
  TITLE: 'There are no students in the main cohort',
  MESSAGE:
    'To move students back to the main cohort, hover over one of extensions in the extension list and click on the 3 dots to edit it and remove students.',
};

export const UWS_INSTITUTIONS = ['uws', 'uws-test', 'pa-assessments'];

export const COVENTRY_INSTITUTIONS = [
  'coventry',
  'cov-bfmat',
  'cov-cug',
  'cov-london',
  'cov-test',
  'pa-core',
];
